<template>
  <EuiContainer class="w-full" style="height:80vh;">
    <EuiGrid class="my-auto">
      <EuiGridRow class="mt-3">
        <EuiHeading :level="1" class="mx-auto">
          Erreur 404: Page non trouvée
        </EuiHeading>
      </EuiGridRow>
      <EuiGridRow class="mt-3">
        <EuiButton
            class="mx-auto"
            color="primary" variant="raised"
            @click="$router.push({name: 'dashboard'})">
          Retour à l'accueil
        </EuiButton>
      </EuiGridRow>
    </EuiGrid>
  </EuiContainer>
</template>

<script>

export default {
};
</script>
